// extracted by mini-css-extract-plugin
export default {"modelWears":"_IwC5"};